'use client';

import CustomersHomePage from '@/app/(app)/customers-home/page';
import VoiceAgentDashboardPageHome from '@/app/(app)/voice-agent/dashboard/page';
import { useModuleEnabled } from '@/components/providers/modules-provider';

export default function Page() {
  const isCustomersHomeEnabled = useModuleEnabled('customers:home');
  if (isCustomersHomeEnabled) {
    return <CustomersHomePage />;
  }
  return <VoiceAgentDashboardPageHome />;
}
